/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic from "axios";
import type { AxiosInstance, AxiosRequestConfig } from "axios";

export interface IRequestOptions extends AxiosRequestConfig {
    /**
     * show loading status
     */
    loading?: boolean;
    /**
     * display error message
     */
    showError?: boolean;
    /**
     * indicates whether Authorization credentials are required for the request
     * @default true
     */
    withAuthorization?: boolean;
}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
    /** only in axios interceptor config*/
    loading: boolean;
    showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error("please inject yourself instance like axios  ");
    }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
    const configs: IRequestConfig = {
        loading: serviceOptions.loading,
        showError: serviceOptions.showError,
        ...options,
        method,
        url,
    };
    configs.headers = {
        ...options.headers,
        "Content-Type": contentType,
    };
    return configs;
}

export const basePath = "";

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class TimeRecorderService {
    /**
     * Post Record Start Time
     */
    postRecordStartTime(
        params: {
            /**  */
            code: string;
            /**  */
            structureNodeId: string;
            /** requestBody */
            body?: RecordStartTimeDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<RecordedAssignmentWithEmployeeNameDto[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/{structureNodeId}/employeeCodes/{code}/recordStartTime";
            url = url.replace("{code}", params["code"] + "");
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     * Change the group of a recorded assignment
     */
    putRecordedAssignmentGroup(
        params: {
            /**  */
            code: string;
            /**  */
            structureNodeId: string;
            /** requestBody */
            body?: ChangeGroupDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<RecordedAssignmentWithEmployeeNameDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/{structureNodeId}/employeeCodes/{code}/recordedAssignmentGroup";
            url = url.replace("{code}", params["code"] + "");
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("put", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     * Get all groups of a structure node
     */
    getAvailableGroups(
        params: {
            /**  */
            code: string;
            /**  */
            structureNodeId: string;
            /** requestBody */
            body?: DeviceAuthDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<BaseGroupDto[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/{structureNodeId}/employeeCodes/{code}/availableGroups";
            url = url.replace("{code}", params["code"] + "");
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     * Get the main group of an employee
     */
    getEmployeeMainGroup(
        params: {
            /**  */
            code: string;
            /**  */
            structureNodeId: string;
            /** requestBody */
            body?: DeviceAuthDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<BaseGroupDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/{structureNodeId}/employeeCodes/{code}/mainGroup";
            url = url.replace("{code}", params["code"] + "");
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     * Post Record Break End Time
     */
    postRecordBreakEndTime(
        params: {
            /**  */
            code: string;
            /**  */
            structureNodeId: string;
            /** requestBody */
            body?: RecordEndTimeDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<RecordedAssignmentWithEmployeeNameDto[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/{structureNodeId}/employeeCodes/{code}/recordBreakEndTime";
            url = url.replace("{code}", params["code"] + "");
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     * Post Record End Time
     */
    postRecordEndTime(
        params: {
            /**  */
            code: string;
            /**  */
            structureNodeId: string;
            /** requestBody */
            body?: RecordEndTimeDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<RecordedAssignmentWithEmployeeNameDto[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/{structureNodeId}/employeeCodes/{code}/recordEndTime";
            url = url.replace("{code}", params["code"] + "");
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     * Post Record Break Start Time
     */
    postRecordBreakStartTime(
        params: {
            /**  */
            code: string;
            /**  */
            structureNodeId: string;
            /** requestBody */
            body?: RecordStartTimeDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<RecordedAssignmentWithEmployeeNameDto[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/{structureNodeId}/employeeCodes/{code}/recordBreakStartTime";
            url = url.replace("{code}", params["code"] + "");
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    timeRecorderControllerPing(
        params: {
            /** requestBody */
            body?: IncomingDevicePingDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<DevicePingDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/ping";

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     * Post Multiple Recorded Times
     */
    postRecordedTimes(
        params: {
            /** requestBody */
            body?: RecordedTimesDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<RecordedAssignmentWithEmployeeNameDto[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/employeeApi/timeRecorderConnector/recordedTimes";

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class DeviceService {
    /**
     * Updates the device with its deviceId and returns the authentication token. Then the start code is invalidated
     */
    getConfiguration(
        params: {
            /** requestBody */
            body?: LoadDeviceConfigDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<GetDeviceConfigDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/timerecorder/register";

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class EmployeeFeedbackService {
    /**
     * Gather all active employee feedback questions for this tenant
     */
    getEmployeeFeedbackQuestions(
        params: {
            /** The structure node key */
            structureNodeId: string;
            /** requestBody */
            body?: DeviceAuthDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<EmployeeFeedbackQuestionsDto> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/employee-feedback/questions/{structureNodeId}";
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     * Save the given feedback of a employee
     */
    saveEmployeeFeedbackAnswer(
        params: {
            /** The structure node key */
            structureNodeId: string;
            /** requestBody */
            body?: EmployeeFeedbackAnswerDto;
        } = {} as any,
        options: IRequestOptions = {},
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/employee-feedback/answers/{structureNodeId}";
            url = url.replace("{structureNodeId}", params["structureNodeId"] + "");

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

/** RecordStartTimeDto */
export interface RecordStartTimeDto {
    /**  */
    authToken?: string;

    /**  */
    deviceToken?: string;

    /**  */
    photo?: string;
}

/** UserViewFilterPreferences */
export interface UserViewFilterPreferences {
    /**  */
    considerAvailabilitiesAsDesired: boolean;

    /**  */
    hideUnavailableEmployees: boolean;

    /**  */
    groupByContractType: boolean;

    /**  */
    hideEmployeesOnRestDays: boolean;

    /**  */
    onlyFilterMainGroup: boolean;
}

/** UserViewPlannerPreferences */
export interface UserViewPlannerPreferences {
    /**  */
    hiddenGroups: string[];

    /**  */
    employeeFilter: UserViewFilterPreferences;
}

/** UserViewPreferencesDto */
export interface UserViewPreferencesDto {
    /**  */
    planner: UserViewPlannerPreferences;
}

/** UserNotificationSubscriptionsDto */
export interface UserNotificationSubscriptionsDto {
    /**  */
    absence: NotificationSubscriptionChannels[];

    /**  */
    ownAbsences: NotificationSubscriptionChannels[];

    /**  */
    newDocument: NotificationSubscriptionChannels[];

    /**  */
    deadlines: NotificationSubscriptionChannels[];

    /**  */
    tooLateOccurrence: NotificationSubscriptionChannels[];
}

/** UserPreferencesDto */
export interface UserPreferencesDto {
    /**  */
    view: UserViewPreferencesDto;

    /**  */
    preferredLanguage?: string;

    /**  */
    notificationSubscriptions?: UserNotificationSubscriptionsDto;

    /**  */
    useFahrenheit?: boolean;
}

/** UserAuthorizationGroupDto */
export interface UserAuthorizationGroupDto {
    /**  */
    structureNodeId: string;

    /**  */
    authorizationGroupId: string;
}

/** TransportUserDto */
export interface TransportUserDto {
    /**  */
    _id: string;

    /**  */
    email: string;

    /**  */
    firstname: string;

    /**  */
    name: string;

    /**  */
    photo: string;

    /**  */
    preferences: UserPreferencesDto;

    /**  */
    structureNode: string;

    /**  */
    tenant: string;

    /**  */
    right: number;

    /**  */
    authorizationGroups: UserAuthorizationGroupDto[];

    /**  */
    tenantName: string;
}

/** PhotoDto */
export interface PhotoDto {
    /**  */
    clockIn?: string;

    /**  */
    clockOut?: string;
}

/** ApprovalDto */
export interface ApprovalDto {
    /**  */
    setBy: string;

    /**  */
    setByType: string;

    /**  */
    isApproved: boolean;
}

/** RecordedAssignmentWithEmployeeNameDto */
export interface RecordedAssignmentWithEmployeeNameDto {
    /**  */
    _id?: string;

    /**  */
    recordedInStructureNode: string;

    /**  */
    created?: Date;

    /**  */
    updated?: Date;

    /**  */
    employee: string;

    /**  */
    startTime: Date;

    /**  */
    endTime?: Date;

    /**  */
    originalStartTime?: Date;

    /**  */
    originalEndTime?: Date;

    /**  */
    breakInMin?: number;

    /**  */
    updatedStartTime?: boolean;

    /**  */
    updatedEndTime?: boolean;

    /**  */
    updatedStartTimeBy?: EnumUpdatedBy;

    /**  */
    updatedStartTimeByUserAt?: Date;

    /**  */
    updatedStartTimeByUserId?: string;

    /**  */
    updatedStartTimeByUser?: TransportUserDto;

    /**  */
    updatedEndTimeBy?: EnumUpdatedBy;

    /**  */
    updatedEndTimeByUserAt?: Date;

    /**  */
    updatedEndTimeByUserId?: string;

    /**  */
    updatedEndTimeByUser?: TransportUserDto;

    /**  */
    autoClosed?: boolean;

    /**  */
    businessDay?: Date;

    /**  */
    photos: PhotoDto;

    /**  */
    approval?: ApprovalDto;

    /**  */
    group?: string;

    /**  */
    employeeName: string;
}

/** ChangeGroupDto */
export interface ChangeGroupDto {
    /**  */
    authToken?: string;

    /**  */
    deviceToken?: string;

    /**  */
    newGroupId: string;

    /**  */
    recordedAssignmentId: string;
}

/** DeviceAuthDto */
export interface DeviceAuthDto {
    /**  */
    authToken?: string;

    /**  */
    deviceToken?: string;
}

/** BaseGroupDto */
export interface BaseGroupDto {
    /**  */
    _id: string;

    /**  */
    name: string;
}

/** RecordEndTimeDto */
export interface RecordEndTimeDto {
    /**  */
    authToken?: string;

    /**  */
    deviceToken?: string;

    /**  */
    photo?: string;
}

/** IncomingDevicePingDto */
export interface IncomingDevicePingDto {
    /**  */
    lastUpdatedDate?: Date;

    /**  */
    deviceToken: string;

    /**  */
    runningVersion?: string;
}

/** DeviceConfigurationDto */
export interface DeviceConfigurationDto {
    /**  */
    takePictureWhenClockingInOrOut: boolean;

    /**  */
    pinLength: number;

    /**  */
    showBreakButtons: boolean;

    /**  */
    gatherEmployeeFeedback: boolean;

    /**  */
    isGroupSelectionAfterClockInEnabled: boolean;
}

/** DevicePingDto */
export interface DevicePingDto {
    /**  */
    date: Date;

    /**  */
    device: string;

    /**  */
    location: string;

    /**  */
    configuration: DeviceConfigurationDto;
}

/** RecordedTimeDto */
export interface RecordedTimeDto {
    /**  */
    employeeCode: string;

    /**  */
    clockIn?: Date;

    /**  */
    clockOut?: Date;
}

/** RecordedTimesDto */
export interface RecordedTimesDto {
    /**  */
    items: RecordedTimeDto[];
}

/** LoadDeviceConfigDto */
export interface LoadDeviceConfigDto {
    /** Unique identifier of the device */
    deviceId: string;

    /** StartCode given when creating a new device */
    startCode: string;

    /** android\/ios\/windows */
    os: string;
}

/** GetDeviceConfigDto */
export interface GetDeviceConfigDto {
    /**  */
    authToken: string;

    /**  */
    structureNodeId: string;

    /**  */
    pinLength: number;

    /**  */
    takePictureWhenClockingInOrOut: boolean;

    /**  */
    gatherEmployeeFeedback: boolean;

    /**  */
    isGroupSelectionAfterClockInEnabled: boolean;

    /**  */
    showBreakButtons: boolean;

    /**  */
    location: string;
}

/** EmployeeFeedbackQuestionObjectDto */
export interface EmployeeFeedbackQuestionObjectDto {
    /**  */
    de: string;

    /**  */
    en?: string;
}

/** EmployeeFeedbackAnswerOptionDto */
export interface EmployeeFeedbackAnswerOptionDto {
    /**  */
    value: string;

    /**  */
    rank: number;

    /**  */
    bgColor: EmployeeFeedbackAnswerColor;
}

/** EmployeeFeedbackQuestionDto */
export interface EmployeeFeedbackQuestionDto {
    /**  */
    _id: string;

    /**  */
    tenant: string;

    /**  */
    question: EmployeeFeedbackQuestionObjectDto;

    /**  */
    possibleAnswers: EmployeeFeedbackAnswerOptionDto[];

    /**  */
    activeFrom: Date;

    /**  */
    activeUntil: Date;

    /**  */
    activeAtActions: EmployeeFeedbackActiveAtAction[];

    /**  */
    required?: boolean;
}

/** EmployeeFeedbackQuestionsDto */
export interface EmployeeFeedbackQuestionsDto {
    /**  */
    activeQuestions: EmployeeFeedbackQuestionDto[];
}

/** EmployeeFeedbackAnswerObjectDto */
export interface EmployeeFeedbackAnswerObjectDto {
    /**  */
    rank: number;

    /**  */
    value: string;

    /**  */
    bgColor: EmployeeFeedbackAnswerColor;
}

/** EmployeeFeedbackAnswerDto */
export interface EmployeeFeedbackAnswerDto {
    /**  */
    authToken?: string;

    /**  */
    deviceToken?: string;

    /**  */
    answer?: EmployeeFeedbackAnswerObjectDto;

    /**  */
    recordedAssignmentId: string;

    /**  */
    employeeFeedbackQuestionId: string;

    /**  */
    action: EmployeeFeedbackActiveAtAction;
}

export enum EnumUpdatedBy {
    "user" = "user",
    "system" = "system",
    "employee-app" = "employee-app",
}

export enum NotificationSubscriptionChannels {
    "WebAppChannel" = "WebAppChannel",
    "FCMChannel" = "FCMChannel",
    "EmailChannel" = "EmailChannel",
}

export enum EmployeeFeedbackAnswerColor {
    "red" = "red",
    "orange" = "orange",
    "yellow" = "yellow",
    "lightgreen" = "lightgreen",
    "green" = "green",
}

export enum EmployeeFeedbackActiveAtAction {
    "recordStartTime" = "recordStartTime",
    "recordEndTime" = "recordEndTime",
    "recordBreakStartTime" = "recordBreakStartTime",
    "recordBreakEndTime" = "recordBreakEndTime",
}
